export enum UnitSystem {
  Feet = 'feet',
  Meters = 'meters',
}
